import { ActionReducer } from '@ngrx/store';
import * as userProfileActions from '../core/actions/user-profile.actions';

import { loadingStatusAdd, loadingStatusRemove, StatusAction } from '../core/reducers/loading-status.reducer';

type Actions = userProfileActions.Actions;

/**
 * Loading status reducer for main app page - adds or removes loading flag from store.
 */
export const loadingStatus: ActionReducer<any> = (state: string[] = [], {type}: Actions) => {
    switch (type) {
        case userProfileActions.LOAD_REQUEST:
            return loadingStatusAdd(state, new StatusAction(type, userProfileActions.LOAD_REQUEST));
        case userProfileActions.LOAD_SUCCESS:
        case userProfileActions.LOAD_ERROR:
            return loadingStatusRemove(state, new StatusAction(type, userProfileActions.LOAD_REQUEST));

        default:
            return state;
    }
};






// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/reducers/loading-status.reducer.ts